// Lyra Logo Component
// ====================
// Pure text logo using Libre Baskerville serif font
// Replaces previous SVG lyre icon with simple typographic mark

import React from 'react';

interface LyraLogoProps {
  /** Size variant for the logo */
  size?: 'sm' | 'md' | 'lg';
  /** Kept for backward compatibility — ignored since logo is always text */
  showText?: boolean;
  /** Custom className for additional styling */
  className?: string;
}

const sizeMap = {
  sm: 'text-lg',
  md: 'text-2xl',
  lg: 'text-4xl',
};

/**
 * Lyra Logo component — pure text mark in serif font
 */
const LyraLogo: React.FC<LyraLogoProps> = ({
  size = 'md',
  // showText kept in signature for backward compat, intentionally unused
  showText: _showText = true,
  className = '',
}) => {
  return (
    <span
      className={`${sizeMap[size]} font-serif font-bold text-primary-600 dark:text-primary-400 tracking-tight ${className}`}
    >
      Lyra
    </span>
  );
};

/**
 * Icon-only version — returns the same text mark at a compact size
 */
export const LyraIcon: React.FC<{ size?: number; className?: string }> = ({
  className = '',
}) => (
  <span
    className={`text-lg font-serif font-bold text-primary-600 dark:text-primary-400 tracking-tight ${className}`}
  >
    Lyra
  </span>
);

export default LyraLogo;
